import { Box, Button, Text } from '@mantine/core';
import clsx from 'clsx';
import type { FC } from 'react';
import Markdown from 'react-markdown';
import styles from '@/components/flow-card/components/flow-card-view-mode/flow-card-view-mode.module.css';

type FlowCardViewModeProps = {
	color: string;
	isDescriptionView: boolean;
	handleToggleDescriptionView: () => void;
	content?: string;
	contentHeight: number;
	isTruncated?: boolean;
};
export const FlowCardViewMode: FC<FlowCardViewModeProps> = ({
	content,
	isDescriptionView,
	handleToggleDescriptionView,
	color,
	contentHeight,
	isTruncated = false
}) => {
	return (
		<Box
			className={styles.container}
			style={{
				'--type-color': color,
				'--content-height': `${contentHeight}px`
			}}
			translate="no"
		>
			<Box
				className={clsx('notranslate', styles.contentContainer, {
					[styles.truncated]: isTruncated
				})}
				translate="no"
			>
				<Markdown>{content}</Markdown>
			</Box>

			<Button
				className={styles.togglerContainer}
				onClick={handleToggleDescriptionView}
				variant="transparent"
			>
				<Text
					c={color}
					fw={500}
					fz={10}
				>
					{isDescriptionView ? 'Description' : 'Body'}
				</Text>
			</Button>
		</Box>
	);
};
